module.exports = __webpack_public_path__ + "img/h3.736006e2.jpg";